$(document).on('click', '._tab', function(e) {
    let parentBlock = $(this).parents("._tabs-parent")
    let tabId = $(this).attr("data-tab")
    $(parentBlock).find("._tab").removeClass("_active")
    $(this).addClass("_active")
    $(parentBlock).find(".tab-content").removeClass("_active")
    $(parentBlock).find(`.${tabId}`).addClass("_active")
})

$(".currency-select").click(function() {
    if($(this).parents(".exchange-item").hasClass("_open")){
        $(".exchange-item").removeClass("_open")
    } else{
        $(".exchange-item").removeClass("_open")
        $(this).parents(".exchange-item").addClass("_open")
    }
})

$(document).mouseup( function(e){
    let div = $( ".exchange-item" );
    if ( !div.is(e.target)
        && div.has(e.target).length === 0 ) {
        if($(div).hasClass("_open")){
            $(div).removeClass("_open")
        }
    }
});

$(".qa-card__show").click(function () {
    $(this).parents(".qa-card").toggleClass("_active")
    $(this).siblings(".qa-card__hidden").slideToggle()
})

$(".m-spoiler__show").click(function () {
    $(this).parents(".m-spoiler").toggleClass("_active")
    $(this).siblings(".m-spoiler__hidden").slideToggle()
})

$("[data-copy]").click(function () {
    let text = $(this).attr("data-copy")
    let $tmp = $("<textarea>");
    $("body").append($tmp);
    $tmp.val(text).select();
    document.execCommand("copy");
    $tmp.remove();

    $("#copyAlert").addClass("_open")

    setTimeout(()=>{
        $("#copyAlert").removeClass("_open")
    },5000)
})

$("._close-copy-alert").click(function () {
    $(".copy-alert").removeClass("_open")
    $(".m-page").removeClass("fixed-body")
})

$(".pass-toggle").click(function () {
    if($(this).hasClass("_active")){
        $(this).removeClass("_active")
        $(this).siblings("input").attr("type","password")
    } else{
        $(this).addClass("_active")
        $(this).siblings("input").attr("type","text")
    }
})

$(".withdraw-form__all-sum").click(function () {
    let input = $("[data-all-sum]")
    $(input).val(input.attr("data-all-sum"))
})

$("._show-card-alert").click(function () {
    $("#cardAlert").addClass("_open")
    $(".m-page").addClass("fixed-body")
})

$(".fg__close").click(function () {
    $(this).parents(".fg").removeClass("_error")
})


function showLoader() {
    $(".exchange").addClass("_show-loader")
    setTimeout(()=>{
        hideLoader()
    },10000)
}

function hideLoader() {
    $(".exchange").removeClass("_show-loader")
}

function setLabelPlace(){
    let fields = document.querySelectorAll(".fg input,.fg textarea")

    fields.forEach(field => {
        setLabelPosition(field)

        field.onchange = ()=> {
            setLabelPosition(field)
        }

        function setLabelPosition() {
            if(field.value !== ""){
                field.classList.add("_filled")
            } else{
                field.classList.remove("_filled")
            }
        }
    })
}


setLabelPlace()
